import React from "react";
import { Helmet } from "react-helmet-async";

import { SITE_URL, OG_IMAGE } from "./site";
import { LANGS, DEFAULT_LANG, OG_LOCALE } from "../i18n";
import translations from "../i18n/translations";

// Per-route, per-language meta: title, description, canonical, hreflang
// alternates, Open Graph, Twitter, JSON-LD.
// `path` is language-agnostic ("" for home, "/projects", "/projects/slug", ...).
const Seo = ({
  lang = DEFAULT_LANG,
  path = "",
  title,
  description,
  image = OG_IMAGE,
  type = "website",
  jsonLd,
}) => {
  const t = translations[lang] || translations.en;
  const url = `${SITE_URL}/${lang}${path}`;
  const fullTitle = title ? `${title} | ${t.siteName}` : `${t.siteName} | ${t.jobTitle}`;
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {LANGS.map((l) => (
        <link key={l} rel="alternate" hrefLang={l} href={`${SITE_URL}/${l}${path}`} />
      ))}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${SITE_URL}/${DEFAULT_LANG}${path}`}
      />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={t.siteName} />
      <meta property="og:locale" content={OG_LOCALE[lang]} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
